import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

import {
  faCircle as freeFasFaCircle,
  faGlobe as freeFasFaGlobe
} from '@fortawesome/free-solid-svg-icons'

import {
  faGithub as freeFabFaGithub,
  faLinkedin as freeFabFaLinkedin,
  faXTwitter as freeFabFaXTwitter
} from '@fortawesome/free-brands-svg-icons'

library.add(
  freeFasFaCircle,
  freeFasFaGlobe,
  freeFabFaGithub,
  freeFabFaLinkedin,
  freeFabFaXTwitter
)

config.autoAddCss = false

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
